import React from 'react';
import { MdKeyboardArrowRight } from 'react-icons/md';
import Button from '../Button/Button';
import styles from './Calculator.module.css';
import { useTranslation } from '../../hooks/useTranslation';

interface NavigationButtonsProps {
    currentStep: number;
    totalSteps: number;
    canAdvance: boolean;
    onBack: () => void;
    onNext: () => void;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
    currentStep,
    totalSteps,
    canAdvance,
    onBack,
    onNext,
}) => {
    const { t } = useTranslation();

    return (
        <div className={styles.buttonContainer}>
            <Button variant="outline" onClick={onBack} className={styles.backButton}>
                {currentStep === 0 ? t('calculator.success.return') : t('calculator.back')}
            </Button>
            <Button
                variant="primary"
                onClick={onNext}
                rightIcon={<MdKeyboardArrowRight size={24} />}
                className={styles.nextButton}
                disabled={!canAdvance}
            >
                {currentStep === 0
                    ? t('calculator.button')
                    : currentStep === totalSteps - 1
                    ? t('calculator.next')
                    : t('calculator.next')}
            </Button>
        </div>
    );
};

export default NavigationButtons;
